import { render, staticRenderFns } from "./resources.vue?vue&type=template&id=4e31ff7a&scoped=true"
import script from "./resources.vue?vue&type=script&lang=js"
export * from "./resources.vue?vue&type=script&lang=js"
import style0 from "./resources.vue?vue&type=style&index=0&id=4e31ff7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e31ff7a",
  null
  
)

export default component.exports